import React, { useMemo } from "react";

export const UserSelector = ({ value = [], onChange, users = [], showSelectAll = false }) => {
  const allUserIds = useMemo(() => users.map((user) => user.id).filter(Boolean), [users]);
  const allChecked = allUserIds.length > 0 && allUserIds.every((id) => value.includes(id));
  const someChecked = allUserIds.some((id) => value.includes(id)) && !allChecked;

  const grouped = useMemo(() => {
    const groups = {};
    users.forEach(u => {
      const g = u.department?.name || "Unassigned";
      if (!groups[g]) groups[g] = [];
      groups[g].push(u);
    });
    // Sort department names
    return Object.keys(groups).sort().reduce((acc, key) => {
      acc[key] = groups[key];
      return acc;
    }, {});
  }, [users]);

  const toggleUser = (id) => {
    const next = value.includes(id) ? value.filter(i => i !== id) : [...value, id];
    onChange(next);
  };

  const toggleAll = () => {
    if (allChecked) {
      onChange(value.filter((id) => !allUserIds.includes(id)));
    } else {
      onChange([...new Set([...value, ...allUserIds])]);
    }
  };

  const toggleDept = (deptName, ids) => {
    const allChecked = ids.length > 0 && ids.every(id => value.includes(id));
    if (allChecked) {
      onChange(value.filter(id => !ids.includes(id)));
    } else {
      onChange([...new Set([...value, ...ids])]);
    }
  };

  return (
    <div className="border rounded p-2" style={{ maxHeight: '350px', overflowY: 'auto', backgroundColor: '#fcfdfe', fontSize: '13px' }}>
      {showSelectAll && (
        <div className="d-flex align-items-center justify-content-between bg-primary-lt p-2 rounded mb-3 border">
          <label className="form-check mb-0 fw-bold text-primary" style={{ cursor: 'pointer' }}>
            <input
              className="form-check-input"
              type="checkbox"
              checked={allChecked}
              ref={(el) => el && (el.indeterminate = someChecked)}
              onChange={toggleAll}
            />
            <span className="form-check-label ps-1">Select All Staff</span>
          </label>
          <span className="badge bg-primary-lt text-primary">{value.filter((id) => allUserIds.includes(id)).length} / {allUserIds.length}</span>
        </div>
      )}
      {Object.entries(grouped).map(([name, deptUsers]) => {
        const ids = deptUsers.map(u => u.id);
        const allChecked = ids.length > 0 && ids.every(id => value.includes(id));
        const someChecked = ids.some(id => value.includes(id)) && !allChecked;
        
        return (
          <div key={name} className="mb-3">
            <div className="d-flex align-items-center justify-content-between bg-light p-1 px-2 rounded mb-2 border-bottom">
               <label className="form-check mb-0 fw-bold text-primary" style={{ cursor: 'pointer' }}>
                  <input 
                    className="form-check-input" 
                    type="checkbox" 
                    checked={allChecked} 
                    ref={el => el && (el.indeterminate = someChecked)}
                    onChange={() => toggleDept(name, ids)} 
                  />
                  <span className="form-check-label ps-1" style={{ fontSize: '11px', letterSpacing: '0.05em' }}>{name.toUpperCase()}</span>
               </label>
               <span className="badge bg-blue-lt" style={{ fontSize: '10px' }}>{ids.filter(id => value.includes(id)).length} / {ids.length}</span>
            </div>
            <div className="row g-2 px-1">
              {deptUsers.map(u => (
                <div key={u.id} className="col-md-6 col-lg-4">
                  <label className="form-check mb-0 py-1" style={{ cursor: 'pointer' }}>
                    <input className="form-check-input" type="checkbox" checked={value.includes(u.id)} onChange={() => toggleUser(u.id)} />
                    <span className="form-check-label text-truncate d-inline-block w-100" style={{ maxWidth: '150px' }}>{u.name}</span>
                  </label>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default UserSelector;
